let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ejqP4")).then(() => parcelRequire('cTRll'));